var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_INVOICES, GetInvoicesFailureAction, GetInvoicesSuccessAction } from './invoices.action';
import { InvoicesService } from './invoices.service';
var InvoicesEffects = /** @class */ (function () {
    function InvoicesEffects(actions$, invoicesService) {
        var _this = this;
        this.actions$ = actions$;
        this.invoicesService = invoicesService;
        this.getInvoices$ = this.actions$.pipe(ofType(GET_INVOICES), switchMap(function () {
            return _this.invoicesService
                .getInvoices()
                .pipe(map(function (response) { return new GetInvoicesSuccessAction(response); }), catchError(function (error) { return of(new GetInvoicesFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], InvoicesEffects.prototype, "getInvoices$", void 0);
    return InvoicesEffects;
}());
export { InvoicesEffects };
